import React, { useEffect, useState } from "react";
import { Card, Collapse, Row, Col, Tooltip } from "antd";
import {
  TeamOutlined,
  ProductOutlined,
  ManOutlined,
  WomanOutlined,
  HomeOutlined,
  BankOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import "./MapsInicial.css";
import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;

const { Panel } = Collapse;

const DataCol = ({ modulo = "", layout = "default" }) => {
  // layout puede ser: "default" (vista completa) o "compact" (vista en columnas)
  const [datos, setDatos] = useState([]);
  const [totales, setTotales] = useState({
    totalDepartamentos: 0,
    totalMunicipios: 0,
    totalProyectos: 0,
    totalOrganizaciones: 0,
    totalHombres: 0,
    totalMujeres: 0,
    totalParticipantes: 0,
    municipiosPorDepto: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = null;
        if (modulo === "PAATI") {
          response = await axios.get(`${baseUrl}/api/dataColombia`);
        } else {
          response = await axios.get(
            `${baseUrl}/api/dataColombiaSostenibilidad`
          );
        }
        const data = response.data.dataColombia[0];
        const dataOrg = response.data.dataOrg[0];
        const dataCollapse = response.data.dataCollapse;

        // Transforma los datos
        const municipiosPorDepto = dataCollapse.reduce((acc, item) => {
          const listaMunicipios = item.listaMunicipios || "";
          const lista_territorial = item.listaGruposTerritoriales || "";
          const listaProyectos = item.listaProyectos || "";
          const listaParticipantes = item.listaParticipantes || "";

          acc[item.departamento] = {
            municipios: listaMunicipios
              .split("</li><li>")
              .map((m) => m.replace(/<\/?li>/g, "").trim())
              .filter((m) => m.length > 0),
            grupoterritorial: lista_territorial
              .split("</li><li>")
              .map((org) => org.replace(/<\/?li>/g, "").trim())
              .filter((org) => org.length > 0),
            proyectos: listaProyectos
              .split("</li><li>")
              .map((proj) => proj.replace(/<\/?li>/g, "").trim())
              .filter((proj) => proj.length > 0),
            participantesDeptp: listaParticipantes,
          };

          return acc;
        }, {});

        setDatos(data);
        setTotales({
          totalDepartamentos: data.total_deptos || 0,
          totalMunicipios: data.total_municipios || 0,
          totalProyectos: data.total_proyectos || 0,
          totalHombres: dataOrg.Masculino || 0,
          totalMujeres: dataOrg.Femenino || 0,
          totalParticipantes: dataOrg.Total_Participantes || 0,
          municipiosPorDepto: municipiosPorDepto,
        });
      } catch (error) {
        console.error("Error fetching map data:", error);
      }
    };

    fetchData();
  }, [modulo]);

  const iconColor = modulo === "PAATI" ? "#4caf50" : "#2196F3";

  // Configuración según el layout
  const isCompact = layout === "compact";
  const iconSize = isCompact ? "28px" : "48px";
  const titleSize = isCompact ? "16px" : "22px";
  const cardMinHeight = isCompact ? "140px" : "200px";
  const valueSize = isCompact ? "20px" : "32px";
  const percentageSize = isCompact ? "16px" : "24px";
  const labelSize = isCompact ? "12px" : "16px";

  const cards = [
    {
      icon: <BankOutlined style={{ fontSize: iconSize, color: iconColor }} />,
      value: totales.totalDepartamentos,
      label: "Departamentos",
      tooltip: "Total Departamentos",
    },
    {
      icon: <HomeOutlined style={{ fontSize: iconSize, color: iconColor }} />,
      value: totales.totalMunicipios,
      label: "Municipios",
      tooltip: "Total Municipios",
    },
    {
      icon: (
        <ProductOutlined style={{ fontSize: iconSize, color: iconColor }} />
      ),
      value: totales.totalProyectos,
      label: "Proyectos",
      tooltip: "Total Proyectos",
    },
    {
      icon: <ManOutlined style={{ fontSize: iconSize, color: iconColor }} />,
      value: (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span style={{ fontSize: valueSize, fontWeight: "bold" }}>
            {totales.totalHombres}
          </span>
          <span style={{ fontSize: percentageSize, color: "#888" }}>
            {Math.round(
              (totales.totalHombres / totales.totalParticipantes) * 100
            )}
            %
          </span>
        </div>
      ),
      label: "Hombres",
      tooltip: "Total Hombres",
    },
    {
      icon: <WomanOutlined style={{ fontSize: iconSize, color: iconColor }} />,
      value: (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <span style={{ fontSize: valueSize, fontWeight: "bold" }}>
            {totales.totalMujeres}
          </span>
          <span style={{ fontSize: percentageSize, color: "#888" }}>
            {Math.round(
              (totales.totalMujeres / totales.totalParticipantes) * 100
            )}
            %
          </span>
        </div>
      ),
      label: "Mujeres",
      tooltip: "Total Mujeres",
    },
    {
      icon: <TeamOutlined style={{ fontSize: iconSize, color: iconColor }} />,
      value: totales.totalParticipantes,
      label: "Participantes",
      tooltip: "Total Participantes",
    },
  ];

  // Genera los ítems para el Collapse
  const collapseItems = Object.keys(totales.municipiosPorDepto).map(
    (departamento, index) => ({
      key: index,
      label: (
        <span
          style={{
            fontSize: "14px",
            fontWeight: "500",
            wordBreak: "break-word",
          }}
        >
          {departamento}
        </span>
      ),
      children: (
        <div style={{ padding: "8px 0" }}>
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12}>
              <div style={{ marginBottom: "10px" }}>
                <h4
                  className="titleCol"
                  style={{
                    marginBottom: "8px",
                    fontSize: "13px",
                    fontWeight: "600",
                  }}
                >
                  Municipios
                </h4>
                <ul
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    margin: 0,
                    fontSize: "12px",
                    lineHeight: "1.6",
                  }}
                >
                  {totales.municipiosPorDepto[departamento].municipios.map(
                    (municipio, idx) => (
                      <li key={idx} style={{ wordBreak: "break-word" }}>
                        {municipio}
                      </li>
                    )
                  )}
                </ul>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <div style={{ marginBottom: "10px" }}>
                <h4
                  className="titleCol"
                  style={{
                    marginBottom: "8px",
                    fontSize: "13px",
                    fontWeight: "600",
                  }}
                >
                  Proyectos
                </h4>
                <ul
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    margin: 0,
                    fontSize: "12px",
                    lineHeight: "1.6",
                  }}
                >
                  {totales.municipiosPorDepto[departamento].proyectos.map(
                    (proyecto, idx) => (
                      <li key={idx} style={{ wordBreak: "break-word" }}>
                        {proyecto}
                      </li>
                    )
                  )}
                </ul>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <div style={{ marginBottom: "10px" }}>
                <h4
                  className="titleCol"
                  style={{
                    marginBottom: "8px",
                    fontSize: "13px",
                    fontWeight: "600",
                  }}
                >
                  {modulo === "PAATI"
                    ? "Grupos Territoriales"
                    : "Organizaciones"}
                </h4>
                <ul
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    margin: 0,
                    fontSize: "12px",
                    lineHeight: "1.6",
                  }}
                >
                  {totales.municipiosPorDepto[
                    departamento
                  ].grupoterritorial.map((grupo, idx) => (
                    <li key={idx} style={{ wordBreak: "break-word" }}>
                      {grupo}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <div>
                <h4
                  className="titleCol"
                  style={{
                    marginBottom: "8px",
                    fontSize: "13px",
                    fontWeight: "600",
                  }}
                >
                  Participantes
                </h4>
                <div
                  style={{
                    textAlign: "left",
                    fontSize: "12px",
                    lineHeight: "1.6",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      totales.municipiosPorDepto[departamento]
                        .participantesDeptp,
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      ),
    })
  );

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <h3
        className="title-custom text-center"
        style={{
          fontSize: titleSize,
          marginBottom: "16px",
          wordBreak: "break-word",
          lineHeight: "1.4",
        }}
      >
        PROYECTOS DE ASISTENCIA TÉCNICA INTEGRAL
      </h3>

      {/* Cards en grid responsive */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isCompact
            ? "repeat(auto-fit, minmax(120px, 1fr))"
            : "repeat(3, 1fr)", // En default: siempre 2 columnas
          gap: isCompact ? "12px" : "20px",
          marginBottom: "16px",
          width: "100%",
        }}
      >
        {cards.map((item, index) => (
          <Tooltip title={item.tooltip} key={index}>
            <Card
              className="text-center cardCol-hover"
              style={{
                padding: isCompact ? "12px 8px" : "24px 16px",
                minHeight: cardMinHeight,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxSizing: "border-box",
              }}
            >
              <div style={{ marginBottom: isCompact ? "8px" : "12px" }}>
                {item.icon}
              </div>
              <div
                style={{
                  fontSize: valueSize,
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                {item.value}
              </div>
              <p
                style={{
                  color: "#27558a",
                  margin: 0,
                  fontSize: labelSize,
                  fontWeight: "500",
                }}
              >
                {item.label}
              </p>
            </Card>
          </Tooltip>
        ))}
      </div>

      <Collapse
        style={{
          background: modulo === "PAATI" ? "#4caf5020" : "#2196f320",
          textAlign: "left",
          borderRadius: "8px",
          fontSize: "14px",
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        items={collapseItems}
        expandIconPosition="start"
        accordion
      />
    </div>
  );
};

export default DataCol;
